import React from 'react';
import moment from 'moment';
import { IEventGroup, IEventGroupGame } from '../../../../../store/player/events/store';
import { Player } from './Player/Player';

interface IProps {
  item: IEventGroup;
  context?: any;
}

export const Group = (props: IProps) => {
  const { item, context } = props;

  return (
    <div className="group-item">
      <div className="title">{moment(item.start).format('LT')}</div>

      <div className="players">
        {item.games.map((game: IEventGroupGame, index: number) => (
          <Player
            key={`group-player-${index}`}
            item={game}
            context={context}
            roundId={item.round}
          />
        ))}
      </div>
    </div>
  );
};
